import { Dialog, Transition } from "@headlessui/react";
import { format } from "date-fns";
import React, { Fragment, useState } from "react";
import DefaultCurrencyFormat from "../DefaultCurrencyFormat";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";
import { useTranslation } from "../../context/TranslationContext";

const Isitma = ({ result, buyPool, setBuyPool }) => {
  const {
    heatingPoolTitle,
    dateLabel,
    feeLabel,
    statusLabel,
    free,
    notUsable,
    usable,
    closeBtn,
    wantHeatedPool,
    heatedPoolDatesPre,
    heatedPoolDatesClick,
  } = useTranslation();
  let [isOpen, setIsOpen] = useState(false);

  const isitmaTarihler = result?.result?.isitmaUcretleri;
  const isitmaHizmetDisiVarmi = result?.result?.isitmaUcretleri?.filter(
    (e) => e.isitmaHizmetDisi == "1",
  );

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[9999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg text-center font-medium leading-6 text-gray-900 mb-3 "
                  >
                    <h3 className="mb-5 text-lg">
                      {heatingPoolTitle}
                    </h3>
                    <div className="overflow-auto">
                      {/* Tarihleri tabloda göster */}
                      <table className="min-w-full bg-white border border-gray-200">
                        <thead>
                          <tr className="bg-gray-50 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <th className="px-6 py-3">{dateLabel}</th>
                            <th className="px-6 py-3">{feeLabel}</th>
                            <th className="px-6 py-3">{statusLabel}</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {isitmaTarihler?.map((isitmaData, index) => (
                            <tr
                              key={index}
                              className={`${
                                isitmaData.isitmaHizmetDisi == "1"
                                  ? "bg-red-100"
                                  : "bg-green-100"
                              }`}
                            >
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                {format(
                                  new Date(isitmaData.tarih),
                                  "dd.MM.yyyy",
                                )}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {isitmaData.isitmaHizmetDisi == "1" ? (
                                  "-"
                                ) : isitmaData.isitmaFiyat == "0" ? (
                                  free
                                ) : (
                                  <DefaultCurrencyFormat
                                    Symbol={result.result.symbol}
                                    value={isitmaData.isitmaFiyat}
                                  ></DefaultCurrencyFormat>
                                )}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {isitmaData.isitmaHizmetDisi == "1"
                                  ? notUsable
                                  : usable}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button
                      type="button"
                      className="inline-flex mt-5 justify-center rounded-md border border-transparent bg-red-400 px-4 py-2 text-sm font-medium text-white hover:bg-red-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-800 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      {closeBtn}
                    </button>
                  </Dialog.Title>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <div className="bg-detail-border-color h-0.5"></div>
      <div className="py-3 px-6">
        <label className="bg-white p-2 inline-flex items-center cursor-pointer w-full justify-between  content-center ">
          <span className="mr-1 text-xs font-bold text-gray-900 ">
            {wantHeatedPool}
          </span>
          <input
            type="checkbox"
            value=""
            onChange={() => setBuyPool(!buyPool)}
            className="sr-only peer"
            checked={buyPool}
          />
          <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-brand-color-primary"></div>
        </label>

        {isitmaHizmetDisiVarmi && buyPool ? (
          <span
            className="text-xs  text-gray-900 underline inline-block w-full cursor-pointer"
            onClick={openModal}
          >
            {heatedPoolDatesPre} <b>{heatedPoolDatesClick}</b>
          </span>
        ) : (
          ""
        )}
      </div>
      <div className="bg-detail-border-color h-0.5"></div>
    </>
  );
};

export default Isitma;
